import { GlobalIcon } from "get-life-storybook-ts";
import { Fragment } from "react";

interface PaymentStepperProps {
  active?: number;
  translate: (key: string) => string;
}

const PaymentStepper = ({ active = 1, translate }: PaymentStepperProps) => {
  const steps = [
    translate("paymentV3.stepper.price"),
    translate("paymentV3.stepper.payment"),
    translate("paymentV3.stepper.beneficiaries"),
  ];

  return (
    <nav className="paymentV3Stepper" aria-label="progress">
      {steps.map((label, i) => {
        const isDone = i < active;
        const isActive = i === active;
        const bulletMod = isDone
          ? "paymentV3Stepper__bullet--done"
          : isActive
            ? "paymentV3Stepper__bullet--active"
            : "";
        const labelMod = isDone
          ? "paymentV3Stepper__label--done"
          : isActive
            ? "paymentV3Stepper__label--active"
            : "";

        return (
          <Fragment key={label}>
            <div className="paymentV3Stepper__step">
              <span className={`paymentV3Stepper__bullet ${bulletMod}`}>
                {isDone ? (
                  <GlobalIcon iconName="CheckedIcon" size="XS" color="#FFFFFF" />
                ) : isActive ? null : (
                  i + 1
                )}
              </span>
              <span className={`paymentV3Stepper__label ${labelMod}`}>
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <span
                className={`paymentV3Stepper__connector ${
                  isDone ? "paymentV3Stepper__connector--done" : ""
                }`}
              />
            )}
          </Fragment>
        );
      })}
    </nav>
  );
};

export default PaymentStepper;
